import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const API_URL = process.env.REACT_APP_API_URL;

export const authApi = createApi({
    reducerPath: 'authApi',
    baseQuery: fetchBaseQuery({
        baseUrl: API_URL,
        prepareHeaders: (headers, {getState}) => {
            const token = getState().auth.userInfo.token;
            if(token){
                headers.set('authorization', `Bearer ${token}`)
                return headers;
            }
        },
    }),
    endpoints: (build) => ({
        getDetails: build.query({
            query: () => ({
                url: 'perfil',
                method: 'GET',
            }),
        }),
    }),
});

export const {useGetDetailsQuery} = authApi;